document.addEventListener('turbolinks:load', () => {

    const selfGuidedStationSelectPreview = document.getElementById('selfGuidedStationSelectPreview')
    const sgScreen = document.getElementById('sgScreen')
    const selfGuidedStationSelectArea = document.getElementsByClassName('selfGuidedStationSelectArea')
    const stationsNoPreview = document.getElementsByClassName('selfGuidedStationSelectStationNoPreview')
    const stationsWithPreview = document.getElementsByClassName('selfGuidedStationSelectStation')


    if (selfGuidedStationSelectPreview !== null && sgScreen !== null) {
        init()
    }

    function init(){
        for(let area of selfGuidedStationSelectArea){
            area.addEventListener('click', () => {handleAreaClick(area)})
        }
    }

    function handleAreaClick(area){
        if (area.dataset.click_action === "collapse"){
            hideArea(area.dataset.area_id)
            area.dataset.click_action = "expand"
        } else {
            showArea(area.dataset.area_id)
            area.dataset.click_action = "collapse"
        }
    }

    function hideArea(areaId){
        for(let station of stationsNoPreview){
            if (station.dataset.areaid === areaId){
                station.classList.add('hidden')
            }
        }
        for(let station of stationsWithPreview){
            if (station.dataset.areaid === areaId){
                station.classList.add('hidden')
            }
        }
        document.getElementById(`collapseArea_${areaId}`).classList.add('hidden')
        document.getElementById(`expandArea_${areaId}`).classList.remove('hidden')
    }

    function showArea(areaId){
        for(let station of stationsNoPreview){
            if (station.dataset.areaid === areaId){
                station.classList.remove('hidden')
            }
        }
        for(let station of stationsWithPreview){
            if (station.dataset.areaid === areaId){
                station.classList.remove('hidden')
            }
        }
        document.getElementById(`collapseArea_${areaId}`).classList.remove('hidden')
        document.getElementById(`expandArea_${areaId}`).classList.add('hidden')
    }

})